module.exports = {"id":"217852","name":"Kevin Molino","rating":"74","photo":"./data/images/photos/4/217852.png","club":{"name":"Minnesota United FC","logo":"./data/images/clubs/MinnesotaUnitedFC.png"},"positions":["MOC","MD","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinMolino0.json
// module id = 2350
// module chunks = 0